import method from '../payment/method';

export const getMethodTransfer = async () => {
  return method.filter((item) => item.show);
};
